import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './assets/styles/portal.scss'

Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })
Vue.config.productionTip = false

Vue.prototype.$aos = AOS

// AOS 初始化（带降级，避免任何情况下内容永久 opacity:0）
function initAOS() {
  const prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  try {
    if (prefersReduced) {
      document.documentElement.classList.add('aos-disabled')
      return
    }
    AOS.init({ duration: 800, once: true, offset: 100 })
    // 字体、图片加载后元素位置可能变化，重新计算触发点
    window.addEventListener('load', () => { try { AOS.refresh() } catch (e) {} })
    // 兜底：3 秒后若 AOS 未接管任何元素（无 aos-init），解除隐藏
    setTimeout(() => {
      if (!document.querySelector('.aos-init')) {
        document.documentElement.classList.add('aos-disabled')
      }
    }, 3000)
  } catch (e) {
    document.documentElement.classList.add('aos-disabled')
  }
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted() { initAOS() }
}).$mount('#app')
